<template>
  <div class="attractions-title-block">
    <h2 class="attractions-title">
      <AppLink v-if="to" class="attractions-title__link" :to="to" @click="$emit('show-more-click')">
        {{ title }}
        <IconBase name="right-arrow" class="attractions-title__arrow" :size="arrowSize" />
      </AppLink>
      <template v-else>{{ title }}</template>
    </h2>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { IconBase } from '@/shared/ui/iconBase';
import { useScreenSize } from '@/shared/utils/breakpoints';

import type { RouterLinkProps } from 'vue-router';

defineProps<{
  title: string;
  to?: RouterLinkProps['to'];
}>();

defineEmits<{
  (e: 'show-more-click'): void;
}>();

const { isMobile } = useScreenSize();
const arrowSize = computed(() => (isMobile.value ? 16 : 20));
</script>

<style lang="scss" scoped>
.attractions-title-block {
  display: flex;
  align-items: baseline;
}

.attractions-title {
  margin-bottom: 24px;

  @include base-800-750-extra;

  @include mobile {
    margin-bottom: 16px;

    @include base-700-500-extra;
  }
}

.attractions-title__link {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  color: inherit;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
}

.attractions-title__arrow {
  flex-shrink: 0;
}
</style>
